// extracted by mini-css-extract-plugin
export default {"Upload":"UnderConstruction_Upload__AFkrp","container":"UnderConstruction_container__ajMAY","comingSoon":"UnderConstruction_comingSoon__0oSyI"};